import classNames from 'classnames';
import { FC, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/types/store-types';
import { MediaManager } from '../../../manager/MediaManager';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    imageSrc: string;
    type: string;
    extension: string;
    classname: string;
    link: string;
    styles: Styles;
    website?: string;
  };
};
const Licence: FC<Props> = ({ settings }) => {
  const { styles, type, extension, classname, imageSrc, link } = settings;

  const { generalConfigs } = useSelector((state: RootState) => state.configs);

  useEffect(() => {
    if (type !== 'anjouan' || typeof window === 'undefined') return;

    let retryTimer: ReturnType<typeof setTimeout>;
    const initAnjouan = (): void => {
      if (window.anj_4057005f_5d06_478b_9227_c28099eaf0d9) {
        try {
          window.anj_4057005f_5d06_478b_9227_c28099eaf0d9.init();
        } catch (error) {
          console.error('Anjouan seal initialization error:', error);
        }
      } else {
        // Retry after delay if script not loaded yet
        retryTimer = setTimeout(initAnjouan, 100);
      }
    };

    // Start initialization with small delay to ensure DOM is ready
    const timer = setTimeout(initAnjouan, 500);

    return () => {
      clearTimeout(timer);
      clearTimeout(retryTimer);
    };
  }, [type]);

  const licenceComonent = useMemo(() => {
    if (type === 'anjouan') {
      return (
        <div className="static-footer__anjouan-seal">
          <div
            id="anj-4057005f-5d06-478b-9227-c28099eaf0d9"
            data-anj-seal-id="4057005f-5d06-478b-9227-c28099eaf0d9"
            data-anj-image-size="128"
            data-anj-image-type="basic-small"
          ></div>
        </div>
      );
    }

    if (type === 'iframe') {
      return <iframe title="licence" src={generalConfigs?.gambleLicence ?? ''} style={styles}></iframe>;
    }

    if (type === 'image') {
      return (
        <img
          src={MediaManager.getSrcFromMediaAssets(`licence.${extension || 'svg'}`, '/footer/')}
          className={classNames(classname, 'image_licence')}
          alt="licence"
        />
      );
    }

    if (type === 'composicao') {
      return (
        <a
          style={styles}
          href={link}
          target="_blank"
          className="composicao_icon"
          aria-label="Learn more about Ministério da Fazenda"
        >
          <img src={MediaManager.getSrcFromMediaAssets(imageSrc, '/')} alt="Ministério da Fazenda" />
        </a>
      );
    }

    return (
      <a
        style={styles}
        href={generalConfigs?.gambleLicence ?? ''}
        target="_blank"
        aria-label="Learn more about Curacao"
      >
        <img src={imageSrc || MediaManager.getSrcFromMediaAssets('license.png', '/')} alt="Licence" />
      </a>
    );
  }, [settings]);

  return <div className={'licence_wrapper'}>{licenceComonent}</div>;
};
export default Licence;
